import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ServicePage from './navigation/pages/ServicePage';
import HomePage from './navigation/pages/HomePage';
import ProductPage from './navigation/pages/ProductPage';
import CategoryPage from './navigation/pages/CategoryPage';
import CallPage from './navigation/pages/CallPage';
import OrderPage from './navigation/pages/OrderPage';
import ContactPage from './navigation/pages/ContactPage';
import TermsAndConditions from './navigation/pages/TermsAndConditionsPage';
import NutritionPage from './navigation/pages/NutritionPage';
import CookiesPage from './navigation/pages/CookiesPage';
import SearchPage from './navigation/pages/SearchPage';
import NotificationsPage from './navigation/pages/NotificationsPage';

import { Unitpay } from './features/unitpay/Unitpay';
import { InterfaceSwitcher } from './features/interface/Interface';
import { initialize } from './core/functions/appInitialize';

import { PlaceProvider } from './core/contexts/PlaceContext';
import { RAFProvider } from './core/contexts/RAFContext';
import { SAFProvider } from './core/contexts/SAFContext';
import { UIMemoryProvider } from './core/contexts/UIMemoryContext';
import { CurrenciesProvider } from './core/contexts/CurrenciesContext';
import { InterfaceProvider } from './core/contexts/InterfaceContext';
import { WSProvider } from './core/websockets/WSContext';
import { OrderStore } from './features/orders/contexts/OrderStoreContext';
import { SearchStore } from './features/search/contexts/SearchStoreContext';
import { NotificationStore } from './features/notifications/contexts/NotificationStoreContext';
import { CallStore } from './features/calls/contexts/CallStoreContext';
import { ThemeProvider } from './features/theming/contexts/ThemeContext';

import './App.css';

// Timeout management moved to src/core/functions/timeoutManager.js

const { placeId, userId, pointId, mode, queryParams, productReference } = initialize();

function App() {
  const userDevice = 'device';
  const [ageValid, setAgeValid] = useState(undefined);

  if (!placeId) return <Unitpay />;

  // pp-background-forced => math random on images and logo to replace fast images

  return (
    <div className="App">
      <div className="p-rel oflowh minWH100v bg-app txt-app">
        <div className="p-fix p-full minWH100v bg-app-linear l0" />
        <div className="p-fix p-full minWH100v bg-app-linear90 l1" />
        <div id="app-background-forced" className="p-fix p-full minWH100v bg-app-image l2" />
        <ThemeProvider>
          <PlaceProvider
            placeRoute={{
              placeId,
              userId,
              pointId,
              mode,
              userDevice,
              queryParams,
              productReference,
            }}
          >
            <OrderStore>
              <SearchStore>
                <NotificationStore>
                  <CallStore>
                    <WSProvider>
                      <RAFProvider>
                        <SAFProvider>
                          <UIMemoryProvider>
                            <InterfaceProvider>
                              <CurrenciesProvider>
                                <BrowserRouter basename="/">
                                  <div className="p-rel l4">
                                    <InterfaceSwitcher ageValid={ageValid} />
                                  </div>
                                  <div className="p-rel l3">
                                    <Routes>
                                      <Route path="/service/:serviceId" element={<ServicePage />} />
                                      <Route
                                        path="/category/:categoryId"
                                        element={<CategoryPage />}
                                      />
                                      <Route path="/product/:productId" element={<ProductPage />} />
                                      <Route path="/call" element={<CallPage />} />
                                      <Route path="/order" element={<OrderPage />} />
                                      <Route path="/contact" element={<ContactPage />} />
                                      <Route path="/search" element={<SearchPage />} />
                                      <Route
                                        path="/notifications"
                                        element={<NotificationsPage />}
                                      />
                                      <Route path="/terms" element={<TermsAndConditions />} />
                                      <Route path="/nutrition" element={<NutritionPage />} />
                                      <Route path="/cookies" element={<CookiesPage />} />
                                      <Route
                                        path={`/${placeId}`}
                                        element={
                                          <HomePage ageValid={ageValid} setAgeValid={setAgeValid} />
                                        }
                                      />
                                      <Route
                                        path="/"
                                        element={
                                          <HomePage ageValid={ageValid} setAgeValid={setAgeValid} />
                                        }
                                      />
                                    </Routes>
                                  </div>
                                </BrowserRouter>
                              </CurrenciesProvider>
                            </InterfaceProvider>
                          </UIMemoryProvider>
                        </SAFProvider>
                      </RAFProvider>
                    </WSProvider>
                  </CallStore>
                </NotificationStore>
              </SearchStore>
            </OrderStore>
          </PlaceProvider>
        </ThemeProvider>
      </div>
    </div>
  );
}

export default App;
